const API = {
  GET_USERS: {
    path: '/expert/users',
    method: 'GET',
  },
  GET_FETCH_END_USER_PROFILE: {
    path: '/user/details',
    method: 'GET',
  },
};
export default API;
